/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicMetadata } from './publicMetadata';
import { Tab } from './tab';

export interface WorkspaceList {
    id?: string;
    name?: string;
    selectedTabId?: string;
    /**
     * Type of workspace. Ignored for public workspaces.
     */
    type?: WorkspaceList.TypeEnum;
    userId?: string;
    createdAt?: string;
    lastModifiedAt?: string;
    createdBy?: string;
    lastModifiedBy?: string;
    publicMetadata?: PublicMetadata;
    imageUrl?: string;
    tabs?: Array<Tab>;
}
export namespace WorkspaceList {
    export const TypeEnum = {
        Personal: 'PERSONAL',
        Company: 'COMPANY'
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
